import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const OPUS_URL = process.env.REACT_APP_OPUS_URL || "https://opus-dashboard-dev.aelive.cloud/";

const NoSessionScreen = () => {
  const handleLaunchOpus = () => {
    window.open(OPUS_URL, "_blank");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#1E1E1E",
        color: "#FFFFFF",
        textAlign: "center",
        padding: 3,
      }}
    >
      <Box
        sx={{
          backgroundColor: "#2A2A2A",
          borderRadius: 2,
          padding: 6,
          maxWidth: 520,
          border: "1px solid rgba(255, 255, 255, 0.12)",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: 'white',
            marginBottom: 3,
            fontWeight: 500,
          }}
        >
          No session found. Please access this application through OPUS.
        </Typography>

        <Button
          variant="contained"
          onClick={handleLaunchOpus}
          endIcon={<OpenInNewIcon />}
          sx={{
            backgroundColor: "#4FC3F7",
            color: 'text.primary',
          }}
        >
          Launch OPUS
        </Button>
      </Box>
    </Box>
  );
};

export default NoSessionScreen;
